export const DROPZONE_ACCEPT = {
  'text/csv': ['.csv'],
};

export const MAX_FILE_SIZE = 20 * 1024 * 1024;

export const boxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '200px',
  width: '100%',
  paddingRight: 3,
  border: '1px solid #1b4332',
  borderRadius: '8px',
};
